<script>
    export default {
        props: {
        },
        data() {
            return {
                target: false,
            }
        },
        methods: {
            keyEnter(e) {
                let key = e.which || e.keyCode;
                if (key !== 13) return;
                if (this.target) this.$emit('search');
            },
            enterForm() {
                this.target = true;
            },
            leaveForm() {
                this.target = false;
            },
        },
        computed: {},
        watch: {},
        components: {},
        mounted() {
            document.addEventListener('keydown', this.keyEnter)
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.keyEnter)
        },
    }
</script>
<template>
    <div @mouseenter="enterForm" @mouseleave="leaveForm">
        <slot></slot>
    </div>
</template>